import { render, staticRenderFns } from "./MediaLibraryModal.vue?vue&type=template&id=2c824258&"
import script from "./MediaLibraryModal.vue?vue&type=script&lang=js&"
export * from "./MediaLibraryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports